export default "__VITE_ASSET__DAXGpTvl__"